import { SubscriptionType } from '../../generated/api/subscriptionType';
import { openDialog } from '../../public/site/dialogStore.js';
import { DialogType } from '../enums.js';
import { fetchStartBroadbandFixer, fetchStartMobileFixer } from '../fetch';
import { type Locale, somethingWentWrongMsg, t } from '../i18n';
import { useSearchParams } from './useSearchParams';
import type { Subscription } from '../../generated/api/subscription';

export const useStartFixer = () => {
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return async (sub: Subscription, locale: Locale, portal: 'NOE' | 'EOE') => {
    try {
      const isMobile =
        sub.subscriptionType === SubscriptionType.MOBILE || sub.subscriptionType === SubscriptionType.MOBILE_BROADBAND;
      const fetcher = isMobile ? fetchStartMobileFixer : fetchStartBroadbandFixer;
      const resp = await fetcher(sub.subscriptionId, locale, portal, mdmId);
      window.location.href = resp.fixerUrl;
    } catch {
      openDialog({
        body: t.JDTO(somethingWentWrongMsg),
        header: t.R28N('Starting broadband fixer failed'),
        type: DialogType.GENERIC_INFO_DIALOG,
      });
    }
  };
};
